import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import AlertMessage from './AlertMessage';
import './App.css';
import Footer from './footer/Footer';
import Loading from './Loading';
import NavBar from './navbar/NavBar';
import Routes from './routes/Routes';

function App() {
  const loading = useSelector(state => state.loading)
  const userInfo = useSelector(state => state.userInfo)
  const [token, setToken] = useState()
  const location = useLocation();
  // if !token and path is home background image

  useEffect(()=>{
    setToken(window.localStorage.getItem('token'))
},[token])
  return (
    <>
    <div className={`App 
      ${!userInfo && location.pathname === "/" ? 'AppHomeBackground' : ''}
      ${location.pathname === "/login" ? 'LoginBackround' : ''}
      `}>
      <NavBar/>
      <AlertMessage/>
      {loading ? <Loading/> : ''}
      <Routes/>
      <Footer/>
    </div>
    </>
  );
}

export default App;
